import { CdkStepper } from "@angular/cdk/stepper";
import { Component, Input, QueryList } from "@angular/core";
import { startWith, takeUntil } from "rxjs/operators";
import { QuicksignStepComponent } from "./quicksign-step/quicksign-step.component";

@Component({
  selector: "quicksign-stepper",
  templateUrl: "./quicksign-stepper.component.html",
  styleUrls: ["./quicksign-stepper.component.css"],
  providers: [{ provide: CdkStepper, useExisting: QuicksignStepperComponent }],
})
export class QuicksignStepperComponent extends CdkStepper {
  readonly steps: QueryList<QuicksignStepComponent> =
    new QueryList<QuicksignStepComponent>();
  // readonly stepHeaders: QueryList<QuicksignStepComponent> =
  //   new QueryList<QuicksignStepComponent>();
  // readonly stepButtons: QueryList<QuicksignStepComponent> =
  //   new QueryList<QuicksignStepComponent>();

  @Input()
  activeClass = "active";

  @Input() containerClass = "qs-container";

  ngAfterContentInit() {
    this._steps.changes
      .pipe(startWith(this._steps), takeUntil(this._destroyed))
      .subscribe((steps: QueryList<QuicksignStepComponent>) => {
        this.steps.reset(
          steps.filter((step) => step._stepper === this && step.isStep)
        );
        this.steps.notifyOnChanges();
        // this.stepHeaders.reset(
        //   steps.filter(
        //     (step) => step._stepper === this && step.isHeader
        //   )
        // );
        // this.stepHeaders.notifyOnChanges();
        // this.stepButtons.reset(
        //   steps.filter(
        //     (step) => step._stepper === this && step.isButton
        //   )
        // );
        // this.stepButtons.notifyOnChanges();
      });
  }

  get isCompleted() {
    return !this.steps.some((step) => step.completed === false);
  }

  isNextButtonHidden() {
    return !(this.steps.length === this.selectedIndex + 1);
  }

  hasPrevious() {
    return this.selectedIndex > 0;
  }
  hasNext() {
    return this.selectedIndex < this.steps.length - 1;
  }
}
